// Faza 2B (2.1): jedno źródło ceny — backend catalog (/api/tickets z manifestu).
// Frontend NIE trzyma cen; content.js ma tylko prezentację (ikony/badge/highlight).
import { useEffect, useState } from "react";
import { getTickets } from "./api";

// Mapa key -> { amount, currency } z backendu. amount jest w jednostkach głównych (PLN).
export function useCatalog() {
  const [catalog, setCatalog] = useState(null); // null=ładowanie, {}=pusto
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const tickets = await getTickets();
        if (cancelled) return;
        const byKey = {};
        for (const t of tickets || []) {
          byKey[t.key] = {
            amount: t.amount,
            currency: (t.currency || "").toUpperCase(),
            admitCount: typeof t.admit_count === "number" ? t.admit_count : 1,
            participantPolicy: t.participant_policy || "buyer_only",
          };
        }
        setCatalog(byKey);
      } catch (e) {
        if (!cancelled) setError(e);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return { catalog, error };
}

// Bezpieczny odczyt ceny: zwraca liczbę PLN albo null gdy katalog jeszcze nie gotowy.
export function ticketPrice(catalog, key) {
  if (!catalog || !catalog[key]) return null;
  const a = catalog[key].amount;
  return typeof a === "number" ? a : null;
}

export function ticketCurrency(catalog, key) {
  if (!catalog || !catalog[key]) return "PLN";
  return catalog[key].currency || "PLN";
}

// 2.5: ilu named participants (poza kupującym) wymaga bilet. buyer liczy się jako 1.
// Zwraca 0 dla buyer_only lub gdy katalog niegotowy.
export function requiredNamedParticipants(catalog, key) {
  if (!catalog || !catalog[key]) return 0;
  const { admitCount, participantPolicy } = catalog[key];
  if (participantPolicy !== "named_participants") return 0;
  return Math.max(0, (admitCount || 1) - 1);
}
